import { ROUTES } from 'utils/routeNames';
import { authActions } from 'store';
import { useDispatch } from 'react-redux';
import { clearStorage } from 'utils/storageHelpers';
import { Images } from 'assets/images';
import {
  StyledButton,
  StyledFlexContainer,
  StyledLogOutImage,
  StyledLogOutText,
} from './styled';

export const LoginButtons = ({ isAuth }) => {
  const dispatch = useDispatch();

  const handleLogOut = () => {
    clearStorage();
    dispatch(authActions.logOut());
  };

  return (
    <>
      {isAuth() ? (
        <StyledFlexContainer onClick={handleLogOut}>
          <StyledLogOutImage src={Images.logOut} alt="log-out" />
          <StyledLogOutText>Log Out</StyledLogOutText>
        </StyledFlexContainer>
      ) : (
        <StyledButton to={ROUTES.LOGIN}>Sign In</StyledButton>
      )}
    </>
  );
};
